import React, { useRef, useEffect, useContext } from 'react';

// Components
import Hero from '../../../components/advanced/hero/Hero';
import ProfileBadge from '../../../components/advanced/profileBadge/ProfileBadge';
import Password from './components/password/Password';
import Tooltip from '../../../components/advanced/tooltip/Tooltip';

// Libraries
import { Container, MagicModal } from '@hybris-software/ui-kit';
import { useNavigate } from 'react-router-dom';
import { useUser, PermissionRoute } from '@hybris-software/use-auth';

// Svgs
import Copy from '../../../assets/svgs/Copy';

// Hooks
import useText from '../../../hooks/useText';

// Data
import { RoutesContext } from '../../../contexts/RoutesContext';
import config from '../../../data/config';

// Utils
import dispatcher from '../../../utils/dispatcher';

// Styles
import Style from './PasswordView.module.css';

const PasswordView = () => {
	// Hooks
	const copy = useText('copyTooltip');
	const texts = useText('passwordView');
	const { userInfo } = useUser();
	const navigate = useNavigate();
	// Refs
	const modalRef = useRef();
	// Contexts
	const { paths } = useContext(RoutesContext);

	useEffect(() => {
		document.title = `${config.PLATFORM_NAME} | ${texts?.pageTitle}`;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<PermissionRoute
			// loader={<Loader />}
			minimumLoadingTime={500}
			forLoggedUser={true}
			unAuthorizedAction={() => {
				navigate(paths.auth.login);
			}}
			permissionController={(response) => {
				dispatcher(response.data, navigate, paths);
				return true;
			}}
		>
			<MagicModal ref={modalRef} />

			<Hero>
				<Container>
					<div className={Style.header}>
						<h3 className={Style.title}>{texts?.title}</h3>
						<div className={Style.referral}>
							<div className={Style.referralText}>
								{texts?.cardReferral}{' '}
								{`${config.BASE_URL}auth/register?refcode=${userInfo?.referralCode}` ||
									'--'}
							</div>

							<Tooltip
								valueToCopy={
									`${config.BASE_URL}auth/register?refcode=${userInfo?.referralCode}` ||
									'--'
								}
								copyIcon={<Copy />}
								textCopy={copy?.copied}
							/>
						</div>
					</div>

					<ProfileBadge modalRef={modalRef} />
				</Container>
			</Hero>

			<Container>
				<Password modalRef={modalRef} />
			</Container>
		</PermissionRoute>
	);
};

export default PasswordView;
